import { useEffect } from 'react';
import { CvUsuario } from './CvUsuario';

const CV = ({ id = null }) => {
  useEffect(() => {
    document.title = 'Concursar - Mi CV';
  });
  return (
    <>
      <CvUsuario id={id} validarItems={false} botonMas={true}></CvUsuario>
    </>
  );
};

export default CV;
